/* eslint-disable */
import stripIndent from '../../Vendor/strip-indent';

/**
 * Thrown when the `locales` are invalid
 * @export
 * @class I18nInvalidLocalesError
 * @extends {Error}
 */
export class I18nInvalidLocalesError extends Error {
  /**
   * Creates an instance of I18nInvalidLocalesError
   * @param {string} message The Error `message`
   * @memberof I18nInvalidLocalesError
   */
  constructor(message) {
    super(message);
    this.name = `I18nInvalidLocalesError`;
  }
}

/**
 * Called when the `locales` are invalid
 * @param {any} locales The invalid `locales`
 * @returns {never} never
 */
const throwI18nInvalidLocalesError = (locales) => {
  throw new I18nInvalidLocalesError(
    stripIndent(`
    Expected "locales" to be an Array of "locale"s with a "length" greater than "0";
    Got: "${locales}"
    `),
  );
};

export default throwI18nInvalidLocalesError;
